import { Button, ModalBody, ModalFooter, ModalHeader, useModal, useSnackbar } from "@homebound/beam";
import { useNavigate } from "react-router-dom";
import { createChangeEventsUrl } from "src/RouteUrls";
import { useDeleteChangeEventMutation } from "../../ChangeEventPage.generated";

type DeleteOrExitConfirmationModalProps = { changeEventId: string; projectId: string };

export function DeleteOrExitConfirmationModal(props: DeleteOrExitConfirmationModalProps) {
  const { changeEventId, projectId } = props;
  const { closeModal } = useModal();
  const { triggerNotice } = useSnackbar();
  const navigate = useNavigate();
  const [deleteChangeEventMutation] = useDeleteChangeEventMutation();

  function exit() {
    navigate(createChangeEventsUrl(projectId));
    closeModal();
  }

  return (
    <>
      <ModalHeader>Before You Leave</ModalHeader>
      <ModalBody>
        Are you sure you want to leave this page? Any unsaved changes will be lost.
        <br />
        Alternatively, you can delete the change event and start over.
      </ModalBody>
      <ModalFooter>
        <Button label="Cancel" variant="quaternary" onClick={closeModal} />
        <Button
          label="Delete"
          variant="danger"
          onClick={async () => {
            await deleteChangeEventMutation({ variables: { input: { id: changeEventId } } });
            triggerNotice({ message: "Change event deleted" });
            exit();
          }}
        />
        <Button label="Keep Draft & Exit" onClick={exit} />
      </ModalFooter>
    </>
  );
}
